import * as React from 'react';
import '../Assets/styles/accordion.css';
import { AccordionItem } from '../CommonUI';
import { getFaqs } from '../Api/settingsApiClient';
import { FaqsResponse } from '../Model';

interface FaqState {
    activeId?: number;
    data: FaqsResponse[];
}

interface FaqProps {
    source: string;
    integrationKey: string;
}

export class Faq extends React.Component<FaqProps, FaqState> {
    constructor(props: FaqProps) {
        super(props);
        this.state = { activeId: undefined, data: [] };
        this.handleClick = this.handleClick.bind(this);
        this.replacePlaceholders = this.replacePlaceholders.bind(this);
    }

    public componentDidMount() {
        getFaqs(this.props.source)
        .then((result) => {
            if (result && result.length > 0) {
                this.setState({ data: result });
            }
        });
    }

    public replacePlaceholders(data: string) {
        return data.replace('{KEY}', this.props.integrationKey);
    }

    public handleClick(id: number) {
        const activeId = this.state.activeId === id ? undefined : id;
        this.setState({ activeId });
    }

    public render() {
        const { activeId, data } = this.state;
        return (
            <div className="accordion-wrapper">
                <ul className="accordion-list">
                    {data.map((input, key) => {
                        return (
                            <li className="accordion-list__item" key={key}>
                                <AccordionItem
                                    id={key}
                                    opened={activeId === key}
                                    paragraph={this.replacePlaceholders(input.paragraph)}
                                    title={input.title}
                                    handleClick={this.handleClick}
                                />
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Containers/Faq.tsx